// What sits where the Intercom launcher is (intercomService `cover`); on a free or trial plan the launcher shows again
// only once none does (a paid account never shows it)
export enum IntercomCover {
	GENIE_PANEL = 'genie-panel',
	LINEAGE_EXPLORER = 'lineage-explorer',
}
